import { trackPageview } from './analytics/trackPageview';
import { eventHandler } from './eventHandler';
import { eventSiteHandler } from './eventSiteHandler';
import { teaserHandler } from './teaserHandler';
import { IAnalyticsMessage } from '../../types';

// oxlint-disable-next-line typescript/no-explicit-any
let latestPage: any;

type TAnalyticsMessageHandlerParams = {
  message: IAnalyticsMessage;
  isDotPin?: boolean;
};

export function analyticsMessageHandler({ message, isDotPin }: TAnalyticsMessageHandlerParams) {
  const [eventType, eventParams] = message.value;

  switch (eventType) {
    case 'eventSite':
      message.value[1].page = isNewbuildingPrizeBannerEvent(eventParams)
        ? mergePageWithExtra(latestPage, eventParams.page)
        : latestPage;
      eventSiteHandler(message.value);
      break;

    case 'pageview':
    case 'pageviewSite':
      eventParams.isIframe = true;

      if (eventParams.page) {
        eventParams.page.extra = {
          ...eventParams.page.extra,
          is_dot_pin: isDotPin,
        };
      }

      latestPage = eventParams.page || null;
      trackPageview(eventParams);
      break;

    case 'teaser':
      message.value[1].page = {
        ...latestPage,
        extra: {
          ...latestPage?.extra,
          ...eventParams.page?.extra,
        },
      };
      teaserHandler(message.value);
      break;

    case 'event':
    case 'eventEbc':
    case 'eventEnrich':
      message.value[1].page = withIframeClickId(latestPage, eventParams.page);
      eventHandler(message.value);
      break;
  }
}

function isNewbuildingPrizeBannerEvent(eventParams: Record<string, unknown>) {
  return (
    eventParams.category === 'trap' &&
    eventParams.label === 'purchase_giveaway_banner' &&
    ['show_sopr', 'click_sopr'].includes(String(eventParams.action))
  );
}

type TAnalyticsPage =
  | {
      extra?: Record<string, unknown>;
      [key: string]: unknown;
    }
  | null
  | undefined;

// page события из iframe заменяется page последнего pageview, а click_id есть только в самом событии:
// без него расхлоп на карте не связать с запросом подменного номера (динКТ вторички, SEL-998)
function withIframeClickId(latestPageData: TAnalyticsPage, pageData: TAnalyticsPage) {
  const clickId = pageData?.extra?.click_id;

  if (!clickId) {
    return latestPageData;
  }

  return {
    ...latestPageData,
    extra: {
      ...latestPageData?.extra,
      click_id: clickId,
    },
  };
}

function mergePageWithExtra(latestPageData: TAnalyticsPage, pageData: TAnalyticsPage) {
  if (!latestPageData && !pageData) {
    return undefined;
  }

  return {
    ...latestPageData,
    ...pageData,
    extra: {
      ...latestPageData?.extra,
      ...pageData?.extra,
    },
  };
}
